'use strict';

_.templateSettings.variable = "__tData";

var __globals = {
    translate_strings: {}
};

/**
  * Common Functions : 08 JAN 2020
  * Chapter 247
  *
  *-------------------------------------------------------- */
var __Utils = {
    log: function (text, textStyle) {

        if (window.appConfig && window.appConfig.debug) {

            var consoleTextStyle = '',
                prependForStyle = '';

            if (textStyle && _.isString(text)) {
                consoleTextStyle = textStyle;
                prependForStyle = '%c ';

                console.log(prependForStyle + text, consoleTextStyle);
            } else {
                console.log(text);
            }

        }
    },

    syntaxHighlight: function (json) {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'color: darkorange;'; /*number*/
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'color: red;'; /*key*/
                } else {
                    cls = 'color: green;'; /*string*/
                }
            } else if (/true|false/.test(match)) {
                cls = 'color: blue;'; /*boolean*/
            } else if (/null/.test(match)) {
                cls = 'color: magenta;'; /*null*/
            }
            return '<span style="' + cls + '">' + match + '</span>';
        });
    },

    displayInTabWindow: function (text) {

        if (window.appConfig && window.appConfig.debug) {
            if (text) {
                var textToPrint = '';
                if (_.isObject(text)) {

                    if (_.has(text, 'data')) {
                        textToPrint = '<pre style="font-size:14px; outline: 1px solid #ccc; padding: 10px; margin: 0px;"><strong>URL: </strong>' + text.config.url + ' <strong><br>Method: </strong>' + text.config.method + ' <strong><br>statusText: </strong>' + text.statusText + ' (' + text.status + ') <strong style="color:red"><br>Error Message: ' + text.data.message + '</strong></pre>';
                    }
                    textToPrint += '<pre style="outline: 1px solid #ccc; padding: 5px; margin: 0px;">' + __Utils.syntaxHighlight(JSON.stringify(text, null, 4)) + '</pre>';
                } else {
                    textToPrint = text;
                }


                var dynamicTabWindow = window.open('', '_blank');
                dynamicTabWindow.document.write(textToPrint);
                dynamicTabWindow.document.close(); // necessary for IE >= 10
                dynamicTabWindow.focus(); // necessary for IE >= 10
            } else {
                console.log("__Utils: Text not found for window.")
            }
        }
    },

    openEmailDebugView: function (url) {

        if (window.appConfig && window.appConfig.debug) {
            window.open(url, "__emailDebugView");
            __Utils.info("Request Sent to open Email Debug View.");
        }
    },

    error: function (text) {

        if (window.appConfig && window.appConfig.debug) {
            console.error(text);
        }
    },

    info: function (text) {

        if (window.appConfig && window.appConfig.debug) {
            console.info(text);
        }
    },

    warn: function (text) {

        if (window.appConfig && window.appConfig.debug) {
            console.warn(text);
        }
    },

    throwError: function (text) {

        if (window.appConfig && window.appConfig.debug) {
            throw new Error(text);
        }
    },

    jsdd: function (response) {

        if (window.appConfig && window.appConfig.debug) {

            if (response.__dd && response.__pr) {
                if (!response.__prExecuted) {
                    var prCount = 1;
                    _.forEach(response.__pr, function (__prValue) {

                        var debugBacktrace = '';

                        console.log('%c Server __pr ' + prCount + " --------------------------------------------------", 'color:#f0ad4e');

                        _.forEach(__prValue, function (value, key) {

                            if (key !== 'debug_backtrace') {
                                console.log(value);

                            } else {

                                debugBacktrace = value;
                            }
                        });

                        console.log('%c Reference  --------------------------------------------------', 'color:#f0ad4e');
                        console.log(debugBacktrace);

                        prCount++;
                    });
                    response.__prExecuted = true;
                    console.log("%c ------------------------------------------------------------ __pr end", 'color: #f0ad4e');
                }
            }

            if (response.__dd && response.__clog) {
                if (!response.__clogExecuted) {
                    __Utils.clog(response);

                    response.__clogExecuted = true;
                }
            }

            if (response.__dd && response.__dd === '__dd') {
                if (!response.__ddExecuted) {
                    console.log('%c Server __dd  --------------------------------------------------', 'color:#ff0000');
                    var ddCount = 1;
                    _.forEach(response.data, function (value, key) {

                        if (key !== 'debug_backtrace') {
                            //  console.log('%c __dd item '+ ddCount+" --------------------------------------------------", 'color:#ff0000');
                            console.log(value);
                            ddCount++;
                        } else {
                            console.log('%c Reference  --------------------------------------------------', 'color:#ff0000');
                            console.log(value);
                        }
                    });
                    response.__ddExecuted = true;
                }

                console.log("%c ------------------------------------------------------------ __dd end", 'color: #ff0000');

                throw '------------------------------------------------------------ __dd end.';
            }
        }
    },
    /**
     * Console the items requested from __clog Laraware helper function
     *
     *-------------------------------------------------------- */
    clog: function (clogData) {

        if (!__globals) {
            var __globals = {
                __clogCount: 0
            }
        }

        var clCount = 1,
            clogType = clogData.__clogType ? clogData.__clogType : '';
        _.forEach(clogData.__clog, function (__clogValue) {
            _.forEach(__clogValue, function (value) {
                console.log('%c __clog ' + clogType + ' ' + clCount + " --------------------------------------------------", 'color: #bada55');
                console.log('%c ' + value, 'color: #9c9c9c');
                clCount++;
                __globals.__clogCount++;
            });
        });

        console.log("%c ------------------------------------------------------------ __clog " + clogType + " items end." + ' TotalCount: ' + __globals.__clogCount, 'color: #bada55');
    },
    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     * 
     */
    detectIE: function () {

        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    },

    time: function (text) {
        if (window.appConfig && window.appConfig.debug && (__Utils.detectIE() >= 11 || __Utils.detectIE() == false)) {
            console.time(text);
        }
    },

    timeEnd: function (text) {
        if (window.appConfig && window.appConfig.debug && (__Utils.detectIE() >= 11 || __Utils.detectIE() == false)) {
            console.timeEnd(text);
        }
    },
    /**
    * Templatining Modal
    * @param templateId string template identifer
    * @param responseCallback callback function should return values required for template
    * return void
    *-------------------------------------------------------- */
    modalTemplatize: function (templateId, responseCallback, closeCallback) {
        var $templateStructure = $(templateId),
            _thisDeferred = jQuery.Deferred();;
        var modalEvent = $templateStructure.data('modalEvent'),
            modalCloseEvent = $templateStructure.data('modalCloseEvent'),
            modalId = $templateStructure.data('modalId'),
            compiledTemplate = _.template($templateStructure.html()),
            replaceId = $templateStructure.data('replaceTarget');
        var callbackResponse = {};
        if (responseCallback) {
            $(modalId).on((modalEvent ? modalEvent : 'show') + '.bs.modal', function (e) {
                if (typeof responseCallback === 'function') {
                    callbackResponse = responseCallback(e, $(e.relatedTarget).data());
                    _thisDeferred.resolve(callbackResponse);
                } else {
                    __Utils.error('responseCallback should be function');
                }
                //append rather than replace!
                $(replaceId ? replaceId : 'modal-body').html(compiledTemplate(callbackResponse));
            });
        } else {
            _thisDeferred.resolve(callbackResponse);
        }

        if (closeCallback) {
            $(modalId).on((modalCloseEvent ? modalCloseEvent : 'hidden') + '.bs.modal', function (hiddenEvent) {
                if (typeof closeCallback === 'function') {
                    closeCallback(hiddenEvent, callbackResponse);
                } else {
                    __Utils.error('closeCallback should be function');
                }
            });
        }
        return _thisDeferred.promise();
    },
    queryConvertToObject: function (queryStr) {
        if (_.isString(queryStr)) {
            var queryArr = (queryStr).replace('?', '&').split('&'),
                queryParams = {};
            for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
                var qArr = queryArr[q].split('=');
                queryParams[decodeURIComponent(qArr[0])] = decodeURIComponent(qArr[1]);
            }
            return queryParams;
        } else {
            return queryStr;
        }
    },

    viewReload: function () {
        location.reload();
    },

    /**
     * Underscore template compilation utility
     *
     * @param string {templateName} - html template identifier including (# for id or . for class)
     * @param object {dataObj}
     *     
     * @return formatted html
     *-------------------------------------------------------- */

    template: function (templateName, dataObj) {
        var $templateHtml = $("script" + templateName).html();

        if ($templateHtml) {

            var _template = _.template($templateHtml);

            return _template(dataObj);

        } else {
            return dataObj;
        }
    },

    /**
     * Get URL string based on Laravel Routes.
     *
     * @param  string/object route
     * @param  params object  
     *     
     * @return string
     *-------------------------------------------------------- */

    apiURL: function (route, params) {

        // Check if route is string
        if (_.isString(route)) {
            if (!_.isEmpty(params) && _.isObject(params)) {
                _.forEach(params, function (value, key) {
                    route = route.replace(key, value);
                });
            }
        } else {
            __Utils.error("__Utils:: Invalid API url");
        }

        return route;
    },

    /**
     * Get translate
     *
     * @param  string stringKey
     *     
     * @return string
     *-------------------------------------------------------- */

    getTranslation: function (stringKey, fallBackString) {
        // Check if translation available
        if (__globals.translate_strings[stringKey]) {
            return __globals.translate_strings[stringKey]
        } else {
            return fallBackString ? fallBackString : stringKey;
        }
    },

    /**
     * Get translate
     *
     * @param  string stringKey
     *     
     * @return string
     *-------------------------------------------------------- */
    setTranslation: function (stringKey, stringTranslation) {
        if (_.isObject(stringKey)) {
            __globals.translate_strings = $.extend({}, __globals.translate_strings, stringKey);
            return true;
        } else if (_.isString(stringKey) && stringTranslation) {
            __globals.translate_strings[stringKey] = stringTranslation;
            return true;
        }
        return false;
    }
};

__globals['clog'] = __Utils.clog;

var __DataRequest = {
    __processSubmitForm: function ($this, $thisForm) {
        $thisForm.validate({
            // errorElement: "span",
            errorClass: "lw-validation-error",
            errorPlacement: function (error, element) {
                if ($(element).siblings('.input-group-prepend').length || $(element).siblings('.input-group-append').length) {
                    error.insertAfter($(element).parents('.input-group')).show();
                } else {
                    error.insertAfter(element).show();
                }
            }

        });
        if ($thisForm.valid()) {

            if ($thisForm.data('show-processing')) {
                $thisForm.addClass('lw-form-in-process').prepend('<div class="lw-spinner-box"><div class="spinner-border" role="status"></div><small>' + __Utils.getTranslation('processing') + '</small></div>');
            }

            if ($this.data('action')) {
                $thisForm.attr('action', $this.data('action'));
            }

            __DataRequest.process($thisForm).then(function () {
                if ($thisForm.data('show-processing')) {
                    $thisForm.removeClass('lw-form-in-process').find('.lw-spinner-box').remove();
                }
            });
        } else {
            return false;
        }
    },
    process: function ($this) {
        var isFormRequest = $this.is('form'),
            requestMethod = $this.data('method') ? $this.data('method') : ((isFormRequest === true) ? 'post' : 'get'),
            unsecuredFields = $this.data('unsecured-fields'),
            isSecuredForm = $this.data('secured'),
            requestURL = isFormRequest ? $this.attr('action') : ($this.data('action') ? $this.data('action') : $this.attr('href')),
            processFormFieldsOptions = {};
        if (unsecuredFields) {
            processFormFieldsOptions.unsecuredFields = unsecuredFields.split(',');
        }

        if (isSecuredForm == true) {
            var inputData = __InputSecurity.processFormFields(__Utils.queryConvertToObject(
                (isFormRequest === true) ? $this.serialize() : $this.data('post-data')
            ), processFormFieldsOptions);
        } else {
            var inputData = (isFormRequest === true) ? $this.serialize() : $this.data('post-data');
        }

        var responseCallback = eval($this.data('callback')),
            optionsForRequest = {
                thisScope: $this,
            };

        if (_.isUndefined(responseCallback)) {
            responseCallback = null;
        }

        if ($this.data('pre-callback')) {
            optionsForRequest['preCallback'] = eval($this.data('pre-callback'))
        }

        if ($this.data('showMessage')) {
            optionsForRequest['showMessage'] = $this.data('showMessage')
        }

        return __DataRequest.__protectedAjaxProcess(requestURL, inputData, responseCallback, requestMethod, optionsForRequest);
    },

    post: function (requestURL, inputData, responseCallback, options) {
        inputData = inputData ? inputData : {};
        responseCallback = responseCallback ? responseCallback : null;
        return __DataRequest.__protectedAjaxProcess(requestURL, inputData, responseCallback, 'post', options);
    },

    get: function (requestURL, inputData, responseCallback, options) {
        inputData = inputData ? inputData : {};
        responseCallback = responseCallback ? responseCallback : null;
        return __DataRequest.__protectedAjaxProcess(requestURL, inputData, responseCallback, 'get', options);
    },

    __protectedAjaxProcess: function (requestURL, inputData, responseCallback, requestMethod, options) {
        var _thisDeferred = jQuery.Deferred();


        if (!options) {
            options = {};
        }

        inputData = __Utils.queryConvertToObject(inputData);

        options = $.extend({}, {
            csrf: true,
            thisScope: $(this),
            preCallback: null,
            showMessage: false
        }, options);

        var headers = {},
            $thisScope = options.thisScope;

        if ($thisScope.data('is-request-processing') == true) {
            __Utils.throwError('request already in process');
        }
        $thisScope.data('is-request-processing', true);

        if (options.csrf === true) {
            headers['X-CSRF-TOKEN'] = appConfig.csrf_token
        }

        if (options.preCallback && _.isFunction(options.preCallback)) {
            inputData = options.preCallback(inputData);
        }

        $.ajax({
            type: requestMethod ? requestMethod : 'get',
            // context: this,
            url: requestURL,
            dataType: "JSON",
            data: inputData ? inputData : {},
            headers: headers,
            error: function (errorResponse) {
                $thisScope.data('is-request-processing', false);
                __Utils.timeEnd("DataRequest." + requestMethod + ' ' + requestURL + ' ');
                _thisDeferred.resolve(errorResponse);
                showErrorMessage(errorResponse.responseJSON && errorResponse.responseJSON.message ? errorResponse.responseJSON.message : 'Message not available');
                if (errorResponse.status === 422) {
                    $.each(errorResponse.responseJSON.errors, function (key, value) {
                        // Convert dots(.) to square brackets
                        // key = key.replace(/\.(.+?)(?=\.|$)/g, (m, s) => `[${s}]`);
                        // key = key.replace(/\.(.+?)(?=\.|$)/g, function (m, s) { return ("[" + s + "]"); });

                        if ($thisScope.find('#' + key + '-error').length) {
                            $thisScope.find('#' + key + '-error').text(value).show();
                        } else {
                            if ($thisScope.find('.input-group-prepend ~ [name="' + key + '"]').length || $thisScope.find('[name="' + key + '"] ~ .input-group-append').length) {
                                $('<label id="' + key + '-error" class="lw-validation-error" for="' + key + '">' + value + '</label>').insertAfter($thisScope.find('[name="' + key + '"]').parents('.input-group')).show();
                            } else {
                                $('<label id="' + key + '-error" class="lw-validation-error" for="' + key + '">' + value + '</label>').insertAfter($thisScope.find('[name="' + key + '"]')[0]).show();
                            }
                        }
                    });
                } else {
                    __Utils.displayInTabWindow(errorResponse.responseJSON);
                }
            },
            beforeSend: function () {
                // Handle the beforeSend event
                __Utils.time("DataRequest." + requestMethod + ' ' + requestURL + ' ');
            },
            success: function (successResponse) {

                if (requestMethod == 'post') {
                    if (successResponse.data && (successResponse.data.show_message || options.showMessage)) {
                        if (successResponse.reaction == 1) {
                            showSuccessMessage(successResponse.data.message ? successResponse.data.message : 'Message not available');
                        } else if (successResponse.reaction == 14) {
                            showWarnMessage(successResponse.data.message ? successResponse.data.message : 'Message not available');
                        } else {
                            showErrorMessage(successResponse.data.message ? successResponse.data.message : 'Message not available');
                        }
                    }
                } else if (successResponse.message && (successResponse.show_message || options.showMessage)) {
                    if (successResponse.reaction_code == 1) {
                        showSuccessMessage(successResponse.message);
                    } else if (successResponse.reaction_code == 14) {
                        showWarnMessage(successResponse.message);
                    } else {
                        showErrorMessage(successResponse.message);
                    }
                }

                //check if rediect reaction and redirect when url is present
                if (successResponse.reaction == 21) {
                    if (_.has(successResponse.data, 'redirectUrl')) {
                        window.location = successResponse.data.redirectUrl;
                    }
                }

                successResponse = __InputSecurity.processResponseData(successResponse);
                // var responseCallback = eval($this.data('callback'));
                if (responseCallback && typeof responseCallback === 'function') {
                    responseCallback(successResponse);
                }

                if (successResponse.response_action) {
                    if (successResponse.response_action.type === 'redirect') {
                        window.location = successResponse.response_action.url;
                    } else if (successResponse.response_action.type === 'replace') {
                        $(successResponse.response_action.target).html(
                            successResponse.response_action.content
                        );
                    }
                }
            },
            complete: function (requestResponse) {
                $thisScope.data('is-request-processing', false);
                _thisDeferred.resolve(requestResponse);
                var responseData = requestResponse.responseJSON;
                __Utils.timeEnd("DataRequest." + requestMethod + ' ' + requestURL + ' ');
                // open email debug view if available
                if (responseData && responseData.__emailDebugView) {
                    __Utils.openEmailDebugView(responseData.__emailDebugView);
                }

                // check if __dd is performed
                if (responseData && responseData.__dd) {
                    __Utils.jsdd(responseData);
                }
            }
        });

        return _thisDeferred.promise();
    },
    updateModels: function (scopeName, dataObject) {

        if (scopeName && _.isObject(scopeName)) {
            dataObject = scopeName;
            scopeName = '';
        } else if (!scopeName || !_.isString(scopeName)) {
            scopeName = '';
        } else {
            scopeName = scopeName + '.';
        }

        if (dataObject && !_.isObject(dataObject)) {
            __Utils.error('dataObject should be present as object');
        }

        for (var key in dataObject) {
            if (dataObject && dataObject.hasOwnProperty(key)) {
                var element = dataObject[key],
                    $elements = $.find('[data-model="' + scopeName + key + '"]');
                if ($elements.length) {
                    $.each($elements, function (index, elementItem) {
                        var $elementItem = $(elementItem);
                        if ($elementItem.is('input:radio') || $elementItem.is('input:checkbox')) {
                            if (element && ($elementItem.val() == element)) {
                                $elementItem.prop('checked', true);
                            } else {
                                $elementItem.prop('checked', false);
                            }
                        } else if ($elementItem.is('input') || $elementItem.is('select')) {
                            $elementItem.val(element);
                        } else {
                            $elementItem.text(element);
                        }
                        $elementItem = null;
                    });
                }
                var $htmlElements = $.find('[data-model-html="' + scopeName + key + '"]');
                if ($htmlElements.length) {
                    $.each($htmlElements, function (index, elementItem) {
                        var $htmlElementItem = $(elementItem);
                        $htmlElementItem.html(element);
                        $htmlElementItem = null;
                    });
                }
                // show element if
                var $ifShowHtmlElements = $.find('[data-show-if="' + scopeName + key + '"]');
                if ($ifShowHtmlElements.length) {
                    $.each($ifShowHtmlElements, function (index, elementItem) {
                        var $ifShowHtmlElementItem = $(elementItem);
                        if (eval(element)) {
                            $ifShowHtmlElementItem.show();
                        } else {
                            $ifShowHtmlElementItem.hide();
                        }
                        $ifShowHtmlElementItem = null;
                    });
                }
                $elements = $htmlElements = $ifShowHtmlElements = element = null;
            }
        }
    }
};

/*----------------------DIRECT GLOBALS ---------------------------------------------------------------------------------- */
/**
* Dump and die  
* @param n number of parameters
*
* return void
*-------------------------------------------------------- */
window.__dd = function (arg1, arg2) {

    if (window.appConfig && window.appConfig.debug) {

        console.error("JS __dd --------------------------------------------------");

        var args = Array.prototype.slice.call(arguments);

        for (var i = 0; i < args.length; ++i) {
            console.log(args[i]);
        }

        throw new Error("-------------------------------------------------- JS __dd END");
    }
}

/**
* Print data
* @param n number of parameters
*
* return void
*-------------------------------------------------------- */
window.__pr = function () {

    if (window.appConfig && window.appConfig.debug) {

        console.info("JS __pr --------------------------------------------------");

        var args = Array.prototype.slice.call(arguments);

        for (var i = 0; i < args.length; ++i) {
            console.log(args[i]);
        }

        console.groupCollapsed("-------------------------------------------------- JS __pr END");
        console.trace();
        console.groupEnd();
        //console.info( "-------------------------------------------------- JS __pr END" );
    }
}

/*
* for handling cookies
*/
var __Cookie = {

    set: function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    get: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}

/**
  * Ajax form submission based on form submit
  *
  *-------------------------------------------------------- */
$('body').on('submit', 'form.lw-ajax-form', function (e) {
    e.preventDefault();
    var $this = $(e.target),
        $thisForm = $(this);
    return __DataRequest.__processSubmitForm($this, $thisForm);
});

/**
 * Ajax form submission based on form on change
 *
 *-------------------------------------------------------- */
$('body').on('change', 'form.lw-ajax-form[lwSubmitOnChange]', function (e) {
    e.preventDefault();
    var $this = $(e.target),
        $thisForm = $(this);
    return __DataRequest.__processSubmitForm($this, $thisForm);
});

/**
  * Ajax form submission based on click
  *
  *-------------------------------------------------------- */
$('body').on('click', '.lw-ajax-form-submit-action', function (e) {
    e.preventDefault();
    var $this = $(this),
        $thisForm = $this.parents('form');
    return __DataRequest.__processSubmitForm($this, $thisForm);
});

/**
* Ajax form submission based on click
*
*-------------------------------------------------------- */
$('body').on('click', '.lw-ajax-link-action', function (e) {
    e.preventDefault();
    // var $this = $(this);
    __DataRequest.process($(this));
});

/**
* Ajax form submission based on click
*
*-------------------------------------------------------- */
$('body').on('click', '.lw-ajax-link-action-via-confirm', function (e) {
    e.preventDefault();
    var $this = $(this);

    if ($this.data('confirm')) {
        showConfirmation($this.data('confirm'), function () {
            return __DataRequest.process($this);
        });
    }
});
